import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import List from "./list";

export default function AccessPermits(props) {
    useEffect(() => {
        return () => props.clearParams("access-permits");
    }, []);

    const { match, location } = props;
    const rootUrl = `${match.path}/list`;
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => <List {...props} isTable transition="full" title="Допуски и разрешения" nofilter />}
                />
            </Switch>
        </div>
    );
}
